import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Model as ClientModel } from 'models/user/interface';
import { USER_TYPE } from 'constants/index';

import * as actions from './actions';
import { getUserID } from './config';

type Client = ClientModel & {
  auth: {
    isInProgress: boolean;
    isLoggedIn: boolean;
    error: string | null;
  };
};
const initialState: Client = {
  uid: getUserID(),
  type: USER_TYPE.LISTENER,
  name: '',
  auth: {
    isInProgress: false,
    isLoggedIn: false,
    error: null,
  },
};

export const client = createSlice({
  name: 'client',
  initialState,
  reducers: {
    init: (state, action: PayloadAction<actions.Init>) => {
      state.uid = action.payload.uid || action.payload._id || '';
      state.name = action.payload.name;
      state.email = action.payload.email;
      state.phone = action.payload.phone;
      state.avatarUrl = action.payload.avatarUrl;
      state.type = action.payload.type;
      state.roomsRoles = action.payload.roomsRoles;
      state.roles = action.payload.roles;
      state.status = action.payload.status;
      state.auth.isLoggedIn = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(actions.signIn.pending, (state) => {
      state.auth.isInProgress = true;
    });
    builder.addCase(actions.signInWithToken.pending, (state) => {
      state.auth.isInProgress = true;
    });
    builder.addCase(actions.signIn.fulfilled, (state, action) => {
      state.auth.isInProgress = false;

      if (action.payload.success && action.payload.name) {
        state.auth.isLoggedIn = true;
      }

      if (action.payload.success) {
        state.uid = action.payload.uid || action.payload._id || '';
        state.name = action.payload.name;
        state.email = action.payload.email;
        state.phone = action.payload.phone;
        state.avatarUrl = action.payload.avatarUrl;
        state.type = action.payload.type;
        state.roomsRoles = action.payload.roomsRoles;
        state.roles = action.payload.roles;
        state.status = action.payload.status;
      }
    });
    builder.addCase(actions.signInWithToken.fulfilled, (state, action) => {
      state.auth.isInProgress = false;

      if (action.payload.success && action.payload.name) {
        state.auth.isLoggedIn = true;
      }

      if (action.payload.success) {
        state.uid = action.payload.uid || action.payload._id || '';
        state.name = action.payload.name;
        state.email = action.payload.email;
        state.phone = action.payload.phone;
        state.avatarUrl = action.payload.avatarUrl;
        state.type = action.payload.type;
        state.roomsRoles = action.payload.roomsRoles;
        state.roles = action.payload.roles;
        state.status = action.payload.status;
      }
    });
    builder.addCase(actions.signIn.rejected, (state) => {
      state.auth.isInProgress = false;
    });
    builder.addCase(actions.signInWithToken.rejected, (state) => {
      state.auth.isInProgress = false;
    });

    builder.addCase(actions.signOut.pending, (state) => {
      state.auth.isInProgress = true;
    });
    builder.addCase(actions.signOut.fulfilled, (state) => {
      state.auth.isInProgress = false;
      state.auth.isLoggedIn = false;
      state.auth.error = null;

      state.uid = getUserID();
      state.type = USER_TYPE.LISTENER;
      state.name = '';

      delete state.email;
      delete state.phone;
      delete state.avatarUrl;
      delete state.roomsRoles;
      delete state.roles;
      delete state.status;
    });
    builder.addCase(actions.signOut.rejected, (state) => {
      state.auth.isInProgress = false;
    });
  },
});

export const { init } = client.actions;
export default client.reducer;
